import { Coins, Loader2 } from 'lucide-react';
import { AdminPageHeader, StatCard, useFetcher } from './_P1Common';

export default function AdminMicropayments() {
  const { data, loading } = useFetcher('micropayments');
  if (loading || !data) return <AdminPageHeader icon={Coins} title="Mikroplaćanja"><Loader2 className="animate-spin"/></AdminPageHeader>;
  return (
    <div data-testid="admin-micropayments">
      <AdminPageHeader icon={Coins} title="Mikroplaćanja" subtitle="Otključavanje pojedinačnih članaka"/>
      <div className="px-4 md:px-6 grid grid-cols-2 md:grid-cols-3 gap-3 mb-6">
        <StatCard testid="micro-count" label="Broj transakcija" value={data.total} accent="blue"/>
        <StatCard testid="micro-total-eur" label="Ukupno (EUR)" value={`€${data.total_eur}`} accent="green"/>
      </div>
      <div className="px-4 md:px-6 pb-6 overflow-x-auto rounded-lg border border-zinc-800 mx-4 md:mx-6">
        <table className="min-w-full text-sm">
          <thead className="bg-zinc-900 text-xs text-zinc-400 uppercase">
            <tr>
              <th className="px-4 py-2 text-left">ID</th>
              <th className="px-4 py-2 text-left">Korisnik</th>
              <th className="px-4 py-2 text-left">Članak</th>
              <th className="px-4 py-2 text-left">Iznos</th>
              <th className="px-4 py-2 text-left">Kreirano</th>
            </tr>
          </thead>
          <tbody>
            {(data.items || []).map(i => (
              <tr key={i.id} className="border-t border-zinc-800 hover:bg-zinc-900/50">
                <td className="px-4 py-2 text-xs text-zinc-500">{i.id?.slice(0, 8)}</td>
                <td className="px-4 py-2">{i.user_email || i.user_id || '—'}</td>
                <td className="px-4 py-2">{i.article_slug || i.article_id || '—'}</td>
                <td className="px-4 py-2">€{((i.amount_cents || 0) / 100).toFixed(2)}</td>
                <td className="px-4 py-2 text-xs text-zinc-500">{(i.created_at || '').slice(0, 10)}</td>
              </tr>
            ))}
            {(data.items || []).length === 0 && (
              <tr><td colSpan={5} className="px-4 py-8 text-center text-zinc-500">Nema mikroplaćanja.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
